var _style, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOutreach = function SvgOutreach(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.outreachStyle0{fill:#5952FF;}\r\n\t.outreachStyle1{fill:#F2F2F2;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outreachStyle0 disabledStyle",
    d: "M45.6,7C60,7,81.7,11.5,91.9,21.6c2.6,2.6,6,7.6,6,15.1c0,13.2-10.6,33.3-22.2,45.1c-6,6-15.6,14-28.5,14 c-12.6,0-22.3-8.6-25-11.4C11.5,73.6,3.8,57.3,3.8,42.1c0-9.6,2.7-18,9.6-24.9C19.9,10.7,30.9,7,45.6,7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "outreachStyle1",
    d: "M63.5,59.5c4.9-4.9,6.2-10.9,6.2-14.2c0-2.4-0.6-6-3.6-8.9c-4.6-4.6-9.6-5.9-15.2-5.9c-7,0-11.7,2.2-14.8,5.3 c-2.4,2.4-4.5,6.3-4.5,11.7s2.8,10.6,6,13.7c2.9,2.9,7.4,5,12,5S58.6,64.3,63.5,59.5z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutreach, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outreach.afaa55b8.svg";
export { ForwardRef as ReactComponent };